/**
 * LoadingSpinner.jsx - Loading State Component
 * Phase 3B - Named export only
 */

import React from 'react';

export const LoadingSpinner = ({ message = "Loading..." }) => (
  <div className="flex flex-col items-center justify-center py-12">
    <div className="w-8 h-8 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin mb-3" />
    <p className="text-sm text-slate-500">{message}</p>
  </div>
);
